module.exports = __webpack_public_path__ + "static/media/Stephen_Tyler_Resume_24.fb0eb773.pdf";